import { render, staticRenderFns } from "./workstation.vue?vue&type=template&id=25bce118&scoped=true&"
import script from "./workstation.vue?vue&type=script&lang=ts&"
export * from "./workstation.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "25bce118",
  null
  
)

export default component.exports